import { BOMItem, BOMType } from 'src/app/models/domain';

// eslint-disable-next-line complexity
export const getBomType = (bomItems: BOMItem[]): BOMType | '' => {
  const hasSort = (s: string) => bomItems.some((x) => x.sortString === s);

  if (bomItems.length === 1 && bomItems[0].sortString === '') {
    return BOMType.OneK;
  }

  if (bomItems.length === 2 && hasSort('1') && hasSort('3')) {
    return BOMType.Coinjection;
  }

  if (
    (bomItems.length === 2 && hasSort('1') && hasSort('2')) ||
    (bomItems.length === 3 && hasSort('1') && hasSort('2') && hasSort('3')) ||
    (bomItems.length === 4 && hasSort('1') && hasSort('2') && hasSort('3') && hasSort('4')) ||
    bomItems.length > 4
  ) {
    return BOMType.MultiK;
  }

  if (bomItems.length >= 2 && !['1', '2', '3', '4'].some((n) => hasSort(n))) {
    return BOMType.Assembly;
  }

  return '';
};
